import React, { useState } from 'react';
import {
  LayoutContainer,
  CanvasArea,
  ChatArea,
  ChatMessagesContainer,
  ChatInputContainer,
  ChatExpandButton
} from './DocumentEditLayout.styled';
import DocumentCanvas from './DocumentCanvas';
import HomePageChatWindow from './HomePageChatWindow';
import { ChatInput } from '../../elements/v2/Input';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import UnfoldLessIcon from '@mui/icons-material/UnfoldLess';

/**
 * Document Edit Layout Component
 * 80% canvas (left) / 20% chat (right) split view
 * Allows editing documents while keeping chat context visible
 */
const DocumentEditLayout = ({
  documentId,
  onCloseDocument,
  
  // Chat props
  chatMessages,
  bottomRef,
  selectedAgent,
  agentIsTyping,
  onAddChatMessage,
  onSendToReasoningAgent,
  onSendReasoningToRegularAgent,
  onMarkWizardSubmitted,
  reasoningProgress,
  
  // Chat input props
  customerId,
  textAreaRef,
  handleTextAreaChange,
  showSpinner,
  newMessage,
  handleSendMessage,
  attachment,
  setAttachment,
  isSendMessageClicked,
  handleCleanThread,
  selectedAgentData,
  webSearchEnabled,
  setWebSearchEnabled,
  reasoningModeEnabled,
  handleActivateReasoningAgent,
  chatDocumentsStore,
  handleDocumentsClick,
  showDocumentsDropdown,
  documentsButtonRef,
  handleDocumentsClose,
  handleOpenDocument,
  
  // Document props
  vaultUuid,
  enableAICopilot
}) => {
  const [isChatExpanded, setIsChatExpanded] = useState(false);

  const toggleChatExpansion = () => {
    setIsChatExpanded(!isChatExpanded);
  };

  return (
    <LayoutContainer>
      <ChatArea $isExpanded={isChatExpanded}>
        <ChatMessagesContainer>
          <ChatExpandButton onClick={toggleChatExpansion} title={isChatExpanded ? "Collapse chat" : "Expand chat"}>
            {isChatExpanded ? <UnfoldLessIcon /> : <UnfoldMoreIcon />}
          </ChatExpandButton>
          
          <HomePageChatWindow
            selectedAgent={selectedAgent}
            messages={chatMessages}
            bottomRef={bottomRef}
            height="100%"
            width="100%"
            agentIsTyping={agentIsTyping}
            dataTestId="chat-window-side-panel"
            onAddChatMessage={onAddChatMessage}
            onSendToReasoningAgent={onSendToReasoningAgent}
            onSendReasoningToRegularAgent={onSendReasoningToRegularAgent}
            onMarkWizardSubmitted={onMarkWizardSubmitted}
            reasoningProgress={reasoningProgress}
            displayButtons={false}
          />
        </ChatMessagesContainer>
        
        <ChatInputContainer>
          <ChatInput
            customerId={customerId}
            textAreaRef={textAreaRef}
            onChange={handleTextAreaChange}
            onKeyPress={(e, callback) => {
              if (e.key === "Enter" && !e.shiftKey && !showSpinner) {
                e.preventDefault();
                handleSendMessage();
                callback("");
              }
            }}
            showSpinner={showSpinner}
            newMessage={newMessage}
            handleSendMessage={handleSendMessage}
            onFileUploaded={setAttachment}
            disableSend={isSendMessageClicked}
            onCleanThread={handleCleanThread}
            showWebSearch={selectedAgentData?.actions?.includes('web_search')}
            webSearchEnabled={webSearchEnabled}
            onWebSearchToggle={setWebSearchEnabled}
            showReasoningAgent={true}
            reasoningModeEnabled={reasoningModeEnabled}
            onReasoningAgentClick={handleActivateReasoningAgent}
            showDocuments={true}
            documentCount={chatDocumentsStore?.documentCount || 0}
            onDocumentsClick={handleDocumentsClick}
          />
        </ChatInputContainer>
      </ChatArea>
      
      <CanvasArea $chatExpanded={isChatExpanded}>
        <DocumentCanvas
          documentId={documentId}
          onClose={onCloseDocument}
          agentUuid={selectedAgent?.uuid}
          vaultUuid={vaultUuid}
          enableAICopilot={enableAICopilot}
          onAddChatMessage={onAddChatMessage}
          borderRadius="12px"
          headerBgColor="#F5F7FA"
          footerBgColor="#FFFFFF"
        />
      </CanvasArea>
    </LayoutContainer>
  );
};

export default DocumentEditLayout;

